import { render } from "./ImportVersionModal.vue?vue&type=template&id=9fb79066&scoped=true"
import script from "./ImportVersionModal.vue?vue&type=script&lang=js"
export * from "./ImportVersionModal.vue?vue&type=script&lang=js"

import "./ImportVersionModal.vue?vue&type=style&index=0&id=9fb79066&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fb79066"]])

export default __exports__